import React, { useState, useEffect, useMemo } from "react"
import Rem_filter_page from "../layout/header";
import axios from "axios";

function ReviewSection(props) {
    // var recaptcha = new firebase.auth.RecaptchaVerifier('recaptcha');
    const [verified, setVerified] = useState('');
    function set_url(path) {
        return props?.site_url+path;
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        const regex = /^[A-Za-z]+$/;
        const regex_num = /^[+]?[0-9]+$/;
        const regex_email = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        let error_message = 0;
        if (!regex.test(e.target.user_name.value)) {
            jQuery('.review-errortxtMessage').html("Please enter your name properly.");
            error_message++;
        } else {
            jQuery('.review-errortxtMessage').html("");
        }
        if (!regex_num.test(e.target.user_phone.value)) {
            jQuery('.review-errornumPhone').html("Please enter valid phone number ");
            return;
        }
        else {
            jQuery('.review-errornumPhone').html("");
        }
        if (!regex_email.test(e.target.user_email.value)) {
            jQuery('.review-erroremailMessage').html("Please Fill Valid Email ");

            return;
        }
        else {
            jQuery('.review-erroremailMessage').html("");
        }
        if (!e.target.rating1.value) {
            jQuery('.review-errorreviewMessage').html("Please Fill all the reviews");
            return;
        }
        else {
            jQuery('.review-errorreviewMessage').html("");
        }
        if (!e.target.rating2.value) {
            jQuery('.review-errorreviewMessage').html("Please Fill all the reviews");
            return;
        }
        else {
            jQuery('.review-errorreviewMessage').html("");
        }
        if (!e.target.rating3.value) {
            jQuery('.review-errorreviewMessage').html("Please Fill all the reviews");
            return;
        }
        else {
            jQuery('.review-errorreviewMessage').html("");
        }
        if (!e.target.rating4.value) {
            jQuery('.review-errorreviewMessage').html("Please Fill all the reviews");
            return;
        }
        else {
            jQuery('.review-errorreviewMessage').html("");
        }
        if (!e.target.rating5.value) {
            jQuery('.review-errorreviewMessage').html("Please Fill all the reviews");
            return;
        }
        else {
            jQuery('.review-errorreviewMessage').html("");
        }
        const data = {
            'post_id': props?.trade_id,
            'name': e.target.user_name.value,
            'phone': e.target.user_phone.value,
            'message': e.target.user_message.value,
            'rating': [
                e.target.rating1.value,
                e.target.rating2.value,
                e.target.rating3.value,
                e.target.rating4.value,
                e.target.rating5.value
            ],
            'email': e.target.user_email.value,
        }
        axios.post(set_url("/wp-json/myapi/v1/insert_review"), data).then((response) => {
            if (!response.errors) {
                jQuery('#popup_success_message').show();
                jQuery('.rem_open_single_page').attr('href', response?.data?.data?.url);
                jQuery('.rem_success_msgs').html("Thank you for Reviews");
                 jQuery('.rem_comment_msgs').html(response?.data?.data?.msg);

                // jQuery('.rem_review_rating1_msgs').html(response?.data?.data?.rating_data[0].name  +  response?.data?.data?.rating_data[0].rating);
                // jQuery('.rem_review_rating2_msgs').html(response?.data?.data?.rating_data[1].name  +  response?.data?.data?.rating_data[1].rating);
                // jQuery('.rem_review_rating3_msgs').html(response?.data?.data?.rating_data[2].name  +  response?.data?.data?.rating_data[2].rating);
                // jQuery('.rem_review_rating4_msgs').html(response?.data?.data?.rating_data[3].name  +  response?.data?.data?.rating_data[3].rating);
                // jQuery('.rem_review_rating5_msgs').html(response?.data?.data?.rating_data[4].name  +  response?.data?.data?.rating_data[4].rating);
                // response?.data?.data?.rating_data.forEach((rating_no, index, arr) => {
                //     console.log(rating_no?.name);
                //     console.log(rating_no?.rating);
                //     jQuery('.rem_review_rating_msgs').append(rating_no?.name + rating_no?.rating);
                // });
                e.target.reset();

            }
        });

    }

    function openVerificationBox() {
        // document.getElementById('popup_phone_verification').style.display = 'block';
    }

    // function verifyCode(element) {
    //     const code = document.getElementById('phone_verification').value;
    //     if (code != 'test') {
    //         document.getElementsByClassName('rem_code_error_message')[0].style.display = 'block';
    //         return false;
    //     }
    //     document.getElementById('popup_phone_verification').style.display = 'none';
    //     document.getElementById('remVerifyCode').setAttribute('disabled', '');
    //     document.getElementById('remPhoneNumber').setAttribute('disabled', '');
    //     document.getElementById('rem_submit').removeAttribute('disabled');
    // }

    function removeErrorMessage() {
        document.getElementsByClassName('rem_code_error_message')[0].style.display = 'none';
    }

    function showVerifyButton(element) {
        const phone = element.target.value;
        const regex_num = /^[+]?[0-9]+$/;
        // remVerifyCode
        if (phone) {
            if (!regex_num.test(phone)) {
                document.getElementById('remVerifyCode').style.display = 'none';
                jQuery('.review-errornumPhone').html("Please enter valid phone number ");
                return;
            }
            document.getElementById('remVerifyCode').style.display = 'block';
            jQuery('.review-errornumPhone').html("");
            return;
        }
        document.getElementById('remVerifyCode').style.display = 'none';
    }
    return (<div>
        <Rem_filter_page site_url={props.site_url}></Rem_filter_page>
        <div id="popup_success_message" class="popup-container" >
            <div class="popup-content">
                <h4 class="rem_success_msgs"></h4>

                <p class="rem_comment_msgs"></p>
                <p class="rem_review_rating1_msgs"></p>
                <p class="rem_review_rating2_msgs"></p>
                <p class="rem_review_rating3_msgs"></p>
                <p class="rem_review_rating4_msgs"></p>
                <p class="rem_review_rating5_msgs"></p>
                <button><a class="rem_open_single_page" href="#">Ok</a></button>
            </div>
        </div>
        <div id="popup_phone_verification" class="popup-container" >
            <div class="popup-content">
                <h4 class="rem_success_msgs"></h4>
                <div class="phone_verification_box">
                    <label for="phone_verification">Code</label>
                    <input onKeyPress={removeErrorMessage} type="text" id="phone_verification" name="phone_verification_code" />
                </div>
                <button type="button" class="rem_verify_code"
                // onClick={verifyCode}
                >Ok</button>


            </div>
        </div>
        <form method="post" onSubmit={e => { handleSubmit(e) }}>
            <div class="review-form-container">
                <div class="review-form-form-group">
                    <label>Name</label>
                    <input type="text" name="user_name" placeholder="Enter your name" />
                    <div class="review-errortxtMessage error_msg_comments"></div>
                </div>
                <div class="review-form-form-group">
                    <label>Email</label>
                    <input type="email" name="user_email" placeholder="Enter your email" />
                    <div class="review-erroremailMessage error_msg_comments"></div>
                </div>
                <div class="review-form-form-group">
                    <label>Phone</label>
                    <input type="text" id="remPhoneNumber" onKeyUp={showVerifyButton} name="user_phone" placeholder="Enter your phone number" maxlength="15" />
                    <div class="review-errornumPhone error_msg_comments"></div>
                    <button onClick={openVerificationBox} id="remVerifyCode" type="button" class="btn btn-primary rem_hide">
                        Verify
                        <img src="https://i.gifer.com/origin/34/34338d26023e5515f6cc8969aa027bca_w200.gif" class="rem_hide" id="rem_code_verify_loader" />
                    </button>
                    <div id="recaptcha"></div><span id="phone_verify_msg" class="phone_verify_msg rem_hide">Mobile number verified</span>
                    <small class="rem_code_error_message rem_hide">
                        Please enter valid verification code
                    </small>
                </div>
                <div class="review-form-form-group-rating-container">
                    <div class="review-form-form-group-rating">
                        <label>Review 1</label>
                        <div class="review-form-star-rating">
                            <input type="radio" id="c1-5-stars" name="rating1" value="5" />
                            <label for="c1-5-stars" class="star">&#9733;</label>
                            <input type="radio" id="c1-4-stars" name="rating1" value="4" />
                            <label for="c1-4-stars" class="star">&#9733;</label>
                            <input type="radio" id="c1-3-stars" name="rating1" value="3" />
                            <label for="c1-3-stars" class="star">&#9733;</label>
                            <input type="radio" id="c1-2-stars" name="rating1" value="2" />
                            <label for="c1-2-stars" class="star">&#9733;</label>
                            <input type="radio" id="c1-1-star" name="rating1" value="1" />
                            <label for="c1-1-star" class="star">&#9733;</label>
                        </div>
                    </div>
                    <div class="review-form-form-group-rating">
                        <label>Review 2</label>
                        <div class="review-form-star-rating">
                            <input type="radio" id="c2-5-stars" name="rating2" value="5" />
                            <label for="c2-5-stars" class="star">&#9733;</label>
                            <input type="radio" id="c2-4-stars" name="rating2" value="4" />
                            <label for="c2-4-stars" class="star">&#9733;</label>
                            <input type="radio" id="c2-3-stars" name="rating2" value="3" />
                            <label for="c2-3-stars" class="star">&#9733;</label>
                            <input type="radio" id="c2-2-stars" name="rating2" value="2" />
                            <label for="c2-2-stars" class="star">&#9733;</label>
                            <input type="radio" id="c2-1-star" name="rating2" value="1" />
                            <label for="c2-1-star" class="star">&#9733;</label>
                        </div>
                    </div>
                    <div class="review-form-form-group-rating">
                        <label>Review 3</label>
                        <div class="review-form-star-rating">
                            <input type="radio" id="c3-5-stars" name="rating3" value="5" />
                            <label for="c3-5-stars" class="star">&#9733;</label>
                            <input type="radio" id="c3-4-stars" name="rating3" value="4" />
                            <label for="c3-4-stars" class="star">&#9733;</label>
                            <input type="radio" id="c3-3-stars" name="rating3" value="3" />
                            <label for="c3-3-stars" class="star">&#9733;</label>
                            <input type="radio" id="c3-2-stars" name="rating3" value="2" />
                            <label for="c3-2-stars" class="star">&#9733;</label>
                            <input type="radio" id="c3-1-star" name="rating3" value="1" />
                            <label for="c3-1-star" class="star">&#9733;</label>
                        </div>
                    </div>
                    <div class="review-form-form-group-rating">
                        <label>Review 4</label>
                        <div class="review-form-star-rating">
                            <input type="radio" id="c4-5-stars" name="rating4" value="5" />
                            <label for="c4-5-stars" class="star">&#9733;</label>
                            <input type="radio" id="c4-4-stars" name="rating4" value="4" />
                            <label for="c4-4-stars" class="star">&#9733;</label>
                            <input type="radio" id="c4-3-stars" name="rating4" value="3" />
                            <label for="c4-3-stars" class="star">&#9733;</label>
                            <input type="radio" id="c4-2-stars" name="rating4" value="2" />
                            <label for="c4-2-stars" class="star">&#9733;</label>
                            <input type="radio" id="c4-1-star" name="rating4" value="1" />
                            <label for="c4-1-star" class="star">&#9733;</label>
                        </div>
                    </div>
                    <div class="review-form-form-group-rating">
                        <label>Review 5</label>
                        <div class="review-form-star-rating">
                            <input type="radio" id="c5-5-stars" name="rating5" value="5" />
                            <label for="c5-5-stars" class="star">&#9733;</label>
                            <input type="radio" id="c5-4-stars" name="rating5" value="4" />
                            <label for="c5-4-stars" class="star">&#9733;</label>
                            <input type="radio" id="c5-3-stars" name="rating5" value="3" />
                            <label for="c5-3-stars" class="star">&#9733;</label>
                            <input type="radio" id="c5-2-stars" name="rating5" value="2" />
                            <label for="c5-2-stars" class="star">&#9733;</label>
                            <input type="radio" id="c5-1-star" name="rating5" value="1" />
                            <label for="c5-1-star" class="star">&#9733;</label>
                        </div>
                    </div>
                </div>
                <div class="review-errorreviewMessage error_msg_comments" ></div>
                <div class="review-form-form-group">
                    <label>Comment</label>
                    <textarea required name="user_message" placeholder="Enter your review"></textarea>
                </div>
                <div class="review-form-form-group">
                    <button disabled type="submit" id="rem_submit" class="review-form-btn">Submit</button>


                    <div class="review-successMessage"></div>
                </div>
            </div>
        </form>
    </div>);
}

export default ReviewSection;